import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from '../../../../../../components/ui/utils/cn';
import { Skeleton } from '../../../../../../components/ui';
import styles from './CategoryTab.module.css';

function CategoryTab({
  Icon,
  title,
  subtitle,
  href,
  loading,
  showBtnSearch,
  showComingSoon,
  isLast
}) {
  const { t } = useTranslation('home');
  const [line1, ...rest] = title.split(' ');
  const line2 = rest.join(' ');

  const clickable = !loading && showBtnSearch;
  const Root = clickable ? Link : 'div';
  const rootProps = clickable ? { to: href } : {};

  return (
    <Root
      {...rootProps}
      className={cn(
        styles.tab,
        clickable && styles.clickable,
        !isLast && styles.divided
      )}>
      <div className={styles.content}>
        <div className={styles.head}>
          <div className={styles.iconWrap}>
            <Icon size={32} />
          </div>
          <p className={styles.title}>
            {line1}
            <br />
            {line2}
          </p>
        </div>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      {loading && <Skeleton width='100%' height={48} radius={0} />}
      {!loading && showBtnSearch && (
        <span className={styles.btnSearch}>
          <span className={styles.btnLabel}>{t('CATEGORY_SEARCH')}</span>
        </span>
      )}
      {!loading && showComingSoon && (
        <span className={styles.btnSoon}>
          <span className={styles.btnLabel}>{t('CATEGORY_SOON')}</span>
        </span>
      )}
      {!loading && !showBtnSearch && !showComingSoon && (
        <span className={styles.btnNeutral} />
      )}
    </Root>
  );
}

CategoryTab.propTypes = {
  Icon: PropTypes.elementType,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  href: PropTypes.string,
  loading: PropTypes.bool,
  showBtnSearch: PropTypes.bool,
  showComingSoon: PropTypes.bool,
  isLast: PropTypes.bool
};

export default CategoryTab;
